import { motion } from "framer-motion";
import { Play } from "lucide-react";

export const VideoSection = () => {
  return (
    <section className="py-24 bg-primary relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute w-[400px] h-[400px] bg-accent/5 rounded-full -top-48 right-0 blur-3xl" />
      </div>

      <div className="container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-accent font-semibold text-sm tracking-widest uppercase">Video</span>
          <h2 className="text-4xl md:text-5xl font-montserrat font-bold mt-3 text-white">
            Zobacz nas w akcji
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-4xl mx-auto"
        >
          <div className="aspect-video rounded-2xl overflow-hidden border border-white/10 shadow-2xl shadow-black/30">
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/Wjd8tuRphjw"
              title="Występ komediowy dla firm"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-8 text-white/50 max-w-2xl mx-auto"
        >
          Każdy występ jest dostosowany do potrzeb Twojej firmy i charakteru wydarzenia.
        </motion.p>
      </div>
    </section>
  );
};
